const MAPBOX_TOKEN =
  'pk.eyJ1IjoidGlvdGRldiIsImEiOiJjbGlvdTZnZTkwMm96M21uNWcxcG9hNmlpIn0.VKCE0hOvRMFPSOipLIMe2w';

// Static map for an itinerary: one numbered pin per place, in order.
//
// Returns undefined when the itinerary cannot be drawn, and every caller has to
// handle that. It used to read `countryCode.toUpperCase()` and iterate
// `itinerary.places` unguarded, so an itinerary missing either — one still
// being written, one whose country the generator could not resolve — threw a
// TypeError inside render and took the entire post page down with it
// ("Ooops... That shouldn't have happened").
function itineraryMapboxUrl(
  itinerary,
  locationDetails,
  useBbox,
  width,
  keepMapboxCredits,
) {
  const { countryCode, bbox } = locationDetails || {};
  const places = (itinerary && itinerary.places) || [];
  // Only places that actually have a location can be pinned. Building the list
  // from the located ones and joining also fixes the malformed URL a place
  // without coordinates used to produce: the old loop appended a separator per
  // index rather than per pin, so one unlocated place left a double comma and
  // Mapbox rejected the whole request.
  const pins = places
    .map((place, index) =>
      place && place.coordinates
        ? `pin-l-${index + 1}+004D40(${place.coordinates[0]},${place.coordinates[1]})`
        : null,
    )
    .filter(Boolean)
    .join(',');

  if (!countryCode || !pins) return undefined;
  if (useBbox && !bbox) return undefined;

  return `https://api.mapbox.com/styles/v1/${
    useBbox ? 'tiotdev/clje0u8cz003201quc5dz9wyg' : 'mapbox/streets-v12'
  }/static/${pins}/${useBbox ? JSON.stringify(bbox) : 'auto'}/${
    width || 400
  }x400@2x?access_token=${MAPBOX_TOKEN}&setfilter=[%22!=%22,%22iso_3166_1%22,%22${countryCode.toUpperCase()}%22]&layer_id=admin-0-boundary${
    keepMapboxCredits ? '' : '&logo=false&attribution=false'
  }`;
}

module.exports = itineraryMapboxUrl;
